angular.module( 'acme.view.application.groups.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.groups.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var groupsList = {
        name: 'application.groups.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'GroupsListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/groups/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Manage Groups',
          permissions: ['USER_GROUPS_VIEW']
        }
      };

    $stateProvider
      .state(groupsList);
});
